import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getManagementUGOAvailableColumns, getRealEstatesShort } from './api';

export const path = '/management-ugo/list';

const PageManagementUGO: React.FC = (props) => {
  const ManagementUGO = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getManagementUGOAvailableColumns,
      realEstates: getRealEstatesShort,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ManagementUGO {...props} />;
};

export default PageManagementUGO;
